<template>
    <div class="file-gallery">
      <div
        v-for="(file, index) in files"
        :key="index"
        class="file-card"
      >
        <!-- Remove button -->
        <button
          v-if="removable"
          class="remove-btn"
          type="button"
          @click.stop="emitRemove(index)"
          title="Remove file"
        >
          <i class="material-icons">close</i>
        </button>
  
        <!-- Image preview -->
        <div v-if="isImage(file)" @click="openFile(file)">
          <img :src="file" alt="Preview" class="file-image" />
        </div>
  
        <!-- File placeholder -->
        <div v-else class="file-placeholder" @click="openFile(file)">
          <i class="material-icons file-icon">{{ getFileIcon(file) }}</i>
          <div class="file-name">{{ getFileName(file) }}</div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "FilePreviewGallery",
    props: {
      files: {
        type: Array,
        required: true
      },
      removable: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      isImage(file) {
        return /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i.test(file);
      },
      getFileIcon(file) {
        if (/\.pdf$/i.test(file)) return "picture_as_pdf";
        if (/\.docx?$/i.test(file)) return "description";
        if (/\.xlsx?$/i.test(file)) return "table_chart";
        if (/\.zip|\.rar$/i.test(file)) return "archive";
        if (/\.txt$/i.test(file)) return "article";
        if (/\.mp4|\.mov|\.avi|\.mkv$/i.test(file)) return "movie";
        if (/\.mp3|\.wav|\.ogg$/i.test(file)) return "audiotrack";
        return "insert_drive_file";
      },
      getFileName(file) {
        return decodeURIComponent(file.split("/").pop());
      },
      openFile(file) {
        window.open(file, "_blank");
      },
      emitRemove(index) {
        this.$emit("remove", index);
      }
    }
  };
  </script>
  
  <style scoped>
  .file-gallery {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 16px;
    margin: 20px 0;
  }
  
  .file-card {
    position: relative;
    border: 1px solid #ddd;
    border-radius: 8px;
    overflow: hidden;
    background: #fafafa;
    text-align: center;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }
  
  .file-card:hover {
    transform: scale(1.01);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  }
  
  .file-image {
    width: 100%;
    height: 180px;
    object-fit: cover;
  }
  
  .file-placeholder {
    padding: 30px 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  
  .file-icon {
    font-size: 48px;
    color: #757575;
    margin-bottom: 8px;
  }
  
  .file-name {
    font-size: 14px;
    word-break: break-all;
    color: #333;
  }
  
  /* --- Remove Button --- */
  .remove-btn {
    position: absolute;
    top: 8px;
    right: 8px;
    background: #e53935;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
    transition: all 0.2s ease;
    z-index: 2;
  }
  
  .remove-btn i {
    color: white;
    font-size: 20px;
  }
  
  .remove-btn:hover {
    background: #d32f2f;
    transform: scale(1.1);
  }
  </style>
  